/**
 * 用户信息
 */

import cookie from "../cookie";

/**
 * 用户
 */
var user = {
    /**
     * 获取用户信息
     */
    get: function(){
        if (cookie.get('ut') && cookie.get('ct') && cookie.get('uidal')) {
            return {
              id: cookie.get('uidal')!.substring(0,16),
              nick: cookie.get('uidal')!.substring(16)
            };
        }
        return null; 
    },
    /**
     * 退出登录
     * @param  {function} 退出之后回调
     */
    logOut: function (callback?:any) {
        var date = new Date();
        document.cookie = "pi=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ct=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ut=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "uidal=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        if (callback) {
            callback();
        }
    },
    isLogin: function (){
        if( this.get() ){
            return true;
        }
        else{
            return false;
        }
    },
    /**
     * 当前打开用
     */
    gotoLogin: function(){
        var loginurl = 'https://passport2.eastmoney.com/pub/login?backurl=' + encodeURIComponent(self.location.href)
        self.location.href = loginurl
    },
    /**
     * 外跳用
     */
    gotoLogin2: function () {
        var loginurl = 'https://passport2.eastmoney.com/pub/login?backurl=' + encodeURIComponent(self.location.href)
        self.open(loginurl)
    },
    getUserInfo: function () {
        try {
            let pi: any = cookie.get('pi');
            let ut = cookie.get('ut');
            let ct = cookie.get('ct')

            if (!ut || !ct) {
                return false;
            }
            if (!pi) {
                return false;
            }

            var userInfo = pi.split(';');

            return userInfo;
        } catch (error) {
            return false;
        }
    },
    /**
     * 获取用户名
     */
    getUserName: function () {
        if (!this.getUserInfo()) {
            return '';
        }

        return (<string[]>(this.getUserInfo()))[2];
    },
    /**
     * 获取用户id
     */
    getUserId: function () {
        if (!this.getUserInfo()) {
            return '';
        }

        return (<string[]>(this.getUserInfo()))[0];
    }
};

export default user;



